<div role="main">
  <app-header></app-header>

  <div class="col-md-6 offset-md-1 d-flex align-items-center">
    <span class="text-white-ref ref">Reference ID</span>
    <span class="ref-id-no ms-2">{{ service.referenceFileDetails.referenceId }}</span>
  </div>

  <form (ngSubmit)="next()"  class="referenceheader">
    <div class="row link-container">
      <div class="col-md-auto offset-md-1 mt-3">
        @if (service.hasVisited('reference')) {
          <a class="btn btn-info custom-button" (click)="service.navigateTo('reference')">Contact Information</a>
        }
      </div>
      <div class="col-md-auto mt-3">
        @if (service.hasVisited('file-upload')) {
          <a class="btn btn-info custom-button" (click)="service.navigateTo('file-upload')">File Upload</a>
        }
      </div>
      <div class="col-md-auto mt-3">
        @if (service.hasVisited('review-files')) {
          <a class="btn btn-info custom-button" (click)="service.navigateTo('review-files')">Review & Submit Files</a>
        }
      </div>
      <div class="col-md-auto mt-3">
        <a class="btn btn-info-current custom-button">Initiate Download</a>
      </div>
    </div>
    <div class="row mt-5 mb-3 offset-md-1">
      <div class="text-white">
        <h1 style="font-size: 1rem;">Please confirm the number of files are correct before submitting for final download.</h1>
      </div>
    </div>
    <div class="row offset-md-1">
      <div class="text-white col mb-5">
        <span class="border-1">{{service.referenceFileDetails.files.length}} files will be Uploaded</span>
      </div>
    </div>
    <div class="col mb-3 offset-md-1 mb-4">
      <span class="text-white">
        Once you have verified the number of files, click the ‘Submit Files’ button. Please note, you cannot navigate back once you complete the submission.
      </span> <br>
      <span class="text-white"> Once files have been successfully uploaded, you will receive a Confirmation email. If a problem occurs during the file transfer, you will be notified and asked to re-submit any files that failed. </span>
    </div>
    <div class="g-recaptcha" data-sitekey="your_site_key"></div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
      <p style="color: white">Please do not Cancel or Refresh page</p>
    </ngx-spinner>
    <div class="button-container offset-md-1">
      <button type="button" class="btn-clear" id="dashboardButton" (click)="back()">Back</button>
      <button type="submit" class="btn-enter" id="dashboardButton">Submit Files</button>
    </div>

  </form>
  <app-footer></app-footer>
</div>
